<template>
  <div class="policy">
    <div class="policy-item" v-for="item in newRes" @click="goInf(item)">
      <div>
        <img :src="[ item.ty004 ?item.ty004:require('../../assets/newsImg.png')]" alt="详情图">
      </div>
      <div class="flexgroud">
        <div class="font20 bold cleartext">{{ item.ty002 }}</div>
        <div class="font16 grey cleartext">{{ item.ty003 }}</div>
      </div>
      <div class="look font20" @click="goInf(item)">
        查看详情
      </div>
    </div>

    <div class="noresource" v-if='newRes.length<1'>
      <img src="../../assets/hasNo.png" alt="">
    </div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5]"
        :page-size="100"
        layout="sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "sliderTab",
    "childMenu",
    'search'
  ],
  data() {
    return {
      currentPage: 1,
      pageSize: 5,
      total: 100,
      newRes: [],
    };
  },
  created() {
    this.getNewsOftab();
  },
  watch: {
    sliderTab() {
      this.getNewsOftab();
    },
    childMenu(){
      this.getNewsOftab();
    },
    search() {
      this.currentPage = 1;
      this.pageSize = 5;
      this.getNewsOftab();
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getNewsOftab();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getNewsOftab();
    },
    goInf(item) {
      this.$router.push({name: 'ActiveInf', params: {newsId: item.quoteid, pageId: this.childMenu[this.sliderTab]}});
    },
    getNewsOftab() {
      let search = this.search || '1$;1';
      try {
        if (search == '1$;1' || search.trim().length < 1) {
          this.getData();
        } else {
          this.getsearchData();
        }
      } catch (e) { }
    },
    getsearchData() {
      this.$axios.post(`/api/news/list/${this.childMenu[this.sliderTab].quoteid}/search`, {
        skip: (this.currentPage - 1) * this.pageSize,
        pageSize: this.pageSize,
        word: this.search,
        where: ' and isdelete=0 and ty008=1 order by ty006 desc'
      }).then(res => {
        this.newRes = res.data.data;
        this.total = res.data.count;
      })
    },
    getData() {
      this.$axios.post(`/api/news/list/${this.childMenu[this.sliderTab].quoteid}`, {
        skip: (this.currentPage - 1) * this.pageSize,
        pageSize: this.pageSize,
        where: ' and isdelete=0 and ty008=1 order by ty006 desc'
      }).then(res => {
        this.newRes = res.data.data;
        this.total = res.data.count;
      })
    }
  }
}
</script>

<style scoped>
.policy {
  position: relative;
  width: 100%;
  min-height: 82.2rem;
  padding-bottom: 9.4rem;
}

.policy-item {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-left: 2.4rem;
  margin-top: 2.4rem;
  border: 1px solid #DCDCDC;
  border-radius: 0.4rem;
}

.policy-item img {
  display: block;
  width: 17rem;
  height: 17rem;
  margin-right: 2.3rem;
}

.flexgroud {
  height: 17rem;
  max-width: 70rem;
  flex: 1;
  cursor: pointer;
}

.flexgroud > div:nth-child(1) {
  margin: 1.2rem 0 2.4rem 0;
}

.look {
  width: 12rem;

}

.page {
  position: absolute;
  bottom: 3.8rem;
  left: 50%;
  transform: translateX(-50%);
}

.grey {
  color: #9B9B9B;
}

.noresource > img {
  display: block;
  width: 40rem;
  height: 40rem;
  margin: 20rem auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/policy.vue